<div class="frontpage-widget cover-image-trees-gray">
    <div class="whitebox dark-blue">
        <div class="container">
            <p class="text-muted">V1-KLADDER <i class="fa fa-chevron-right"></i></p>
            <h2 i18n>Start kladde-screening</h2>
            <p><span class="text-muted">Sag:</span> 2233-4455</p>
        </div>
    </div>
  </div>
<div class="container">
  <div class="row my-5" >
    <div class="col-sm-12 col-lg-12">
      <div class="vd-card p-5">
        <div class="row">
          <div class="col-12">
            <h4 i18n>Vælg branche og aktivitet til screening</h4>
            <p class="text-muted">Før vi kan starte skal du vælge hvilke brancher og aktiviteter der skal medtages i screeningen</p>

            <h5 class="text-muted mt-5">Branche</h5>
            <div class="mt-2">
              <input id="box1" type="checkbox" checked />
              <label for="box1">Kemisk industri</label>
            </div>
            <div>
                <input id="box2" type="checkbox" checked />
                <label for="box2">Fremstilling af farmaceutiske råvarer, medicinalvarefabrik</label>
            </div>

            <h5 class="text-muted mt-5">Aktiviteter</h5>
            <div class="mt-2">
              <input id="box3" type="checkbox" checked />
              <label for="box3">Aktiviteter vedt. kemiske processer og produkter (undtagen olieprodukterm kode 001)</label>
            </div>
            <div>
                <input id="box5" type="checkbox" checked />
                <label for="box5">Andet <span class="text-muted">(Kemisk industri)</span></label>
            </div>

            <div>
                <input id="box6" type="checkbox" checked />
                <label for="box6">Andet <span class="text-muted">(Fremstilling af farmaceutiske råvarer, medicinalvarefabrik)</span></label>
            </div>


            <h4 class="mt-5">Vælg punkt for screening</h4>
            <p class="text-muted">Screeningen beregnes for et punkt. Følgende punkt er bestemt for denne lokation:</p>
            <div style="background: #f0f0f0; padding: 1rem; display: inline-block; border-radius: 0.25rem;">
              <p style="margin:0">55° 33' 21.2436'' N, 9° 44' 5.2044'' E <a class="ml-4"> <i class="fa fa-pencil fa-lg"></i>Ret</a> <a target="_blank" href="https://www.google.dk/maps/place/55.556266,+9.734937/@55.5511443,9.7280062,15z/data=!4m5!3m4!7e2!8m2!3d55.5562662!4d9.734937?hl=da" class="ml-4"> <i class="fa fa-map fa-lg"></i>Find på google maps</a></p>
            </div>
            <hr class="mt-5" />
            <button class="btn btn-primary mt-3" ><i class="fa fa-play"></i> Start screening</button>
          </div>
          

        </div>
      </div>
    </div>
  </div>
</div>